import { authRequest } from './index.js'
import { formatResponse } from '@/utils/errorHandler'

/**
 * Retrieve filtered list of users
 * @param {Object} filterParam - Filter parameters for user collection
 * @returns {Object} - Response object with users list or error
 */
export async function userCollection(filterParam) {
  try {
    const result = await authRequest.get('/user', { params: filterParam })
    return formatResponse(result.data, false)
  } catch (error) {
    return formatResponse(null, true, error)
  }
}

/**
 * Retrieve a specific user by ID
 * @param {string|number} id - User ID
 * @returns {Object} - Response object with user data or error
 */
export async function get_user(id) {
  try {
    const result = await authRequest.get(`/user/${id}`)
    return formatResponse(result.data, false)
  } catch (error) {
    return formatResponse(null, true, error)
  }
}

/**
 * Update user information
 * @param {Object} user - User data to update
 * @param {string|number} id - User ID
 * @returns {Object} - Response object with updated user data or error
 */
export async function update_user(user, id) {
  try {
    const result = await authRequest.patch(`/user/${id}`, { user })
    return formatResponse(result.data, false)
  } catch (error) {
    return formatResponse(null, true, error)
  }
}

/**
 * Delete a user
 * @param {string|number} id - User ID to delete
 * @returns {Object} - Response object confirming deletion or error
 */
export async function destroyUser(id) {
  try {
    const result = await authRequest.delete(`/user/${id}`)
    return formatResponse(result.data, false)
  } catch (error) {
    return formatResponse(null, true, error)
  }
}

/**
 * Retrieve available user roles
 * @returns {Object} - Response object with user roles or error
 */
export async function get_user_roles() {
  try {
    const result = await authRequest.get('/user/roles')
    return formatResponse(result.data, false)
  } catch (error) {
    return formatResponse(null, true, error)
  }
}

/**
 * Retrieve current user profile
 * @returns {Object} - Response object with profile data or error
 */
export async function get_profile() {
  try {
    const result = await authRequest.get('user/profile')
    return formatResponse(result, false)
  } catch (error) {
    return formatResponse(null, true, error)
  }
}

/**
 * Update current user profile
 * @param {Object} user - Updated user profile data
 * @returns {Object} - Response object with updated profile or error
 */
export async function update_profile(user) {
  try {
    const result = await authRequest.post('user/update_profile', { user })
    return formatResponse(result, false)
  } catch (error) {
    return formatResponse(null, true, error)
  }
}

/**
 * Create a new user
 * @param {Object} user - User data for creation
 * @returns {Object} - Response object with created user or error
 */
export async function create_user(user) {
  try {
    const result = await authRequest.post('user', { user })
    return formatResponse(result, false)
  } catch (error) {
    return formatResponse(null, true, error)
  }
}